/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_item = {
    readonly title: string | null;
    readonly isSold: boolean | null;
    readonly isListingNotListed: boolean | null;
    readonly isListingUnlisted: boolean | null;
    readonly seller: {
        readonly isInternal: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedSoldHeader_item" | "PdpRespSimilarItemsContainer_item">;
    readonly " $refType": "PdpRespSimilarItemsLanding_item";
};
export type PdpRespSimilarItemsLanding_item$data = PdpRespSimilarItemsLanding_item;
export type PdpRespSimilarItemsLanding_item$key = {
    readonly " $data"?: PdpRespSimilarItemsLanding_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsLanding_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsLanding_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingNotListed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSoldHeader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsContainer_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a1b00e579d033a3a6757b1e59fd3cc1a';
export default node;
